import styles from './admin-contracts-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { booleanHeader, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, Link, textHeader } from '@frontend-workspace/react-shared-lib';
import { IContracts } from '../../_models/contracts';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ContractsGridProps {
  contracts: IContracts[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  getData: () => void,
  dateRange: DateRange<Date>
}

export function ContractsGrid(props: ContractsGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("adminContractsGrid");

  const contractNumberRenderer = (params: ValueFormatterParams) => (
    <Link
      href={`/customers/${params.data.companyNumber}/contracts/${params.value}`}>
      {`${params.value}`}
    </Link>
  );

  const headers = CreateHeaders([
    textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM),
    textHeader("contractNumber", t("standard.contractNo"), HeaderSizeEnum.MEDIUM, { renderer: contractNumberRenderer }),
    textHeader("type", t("standard.contractType"), HeaderSizeEnum.EXTRA_LARGE),
    dateHeader("startDate", t("standard.startDate")),
    dateHeader("nextInvoiceDate", t("standard.nextInvoiceDate")),
    currencyHeader("contractNextInvoiceCost", t("standard.nextInvoiceCost"), HeaderSizeEnum.EXTRA_LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    booleanHeader("isSchoolVersion", t("standard.academicVersion")),
    textHeader("note", t("standard.note"), HeaderSizeEnum.EXTRA_LARGE)
  ])

  return (
    <WebkuaTable
      headers={headers}
      data={props.contracts}
      tableConfig={tableConfig}
      onSetDateRange={props.onDateChange}
      dateRange={props.dateRange}
      onRefresh={props.getData}
    />
  );
}

export default ContractsGrid;